import { AritoIcon } from '@/components/custom/arito/icon';
import { NavMenu } from '../types';

export const taiSanMenu: NavMenu = {
  title: 'Tài sản',
  items: [
    {
      title: 'Khai báo tăng / giảm TSCĐ',
      items: [
        {
          title: 'Khai báo thông tin tài sản cố định',
          icon: <AritoIcon icon={255} />,
          href: '/tai-san/khai-bao-tang-giam-tscd/khai-bao-thong-tin-tscd'
        },
        {
          title: 'Điều chỉnh giá trị TSCĐ',
          icon: <AritoIcon icon={324} />,
          href: '/tai-san/khai-bao-tang-giam-tscd/dieu-chinh-gia-tri-tscd'
        }
      ],
      group: 0
    },
    {
      title: 'Điều chỉnh giá trị TSCĐ',
      href: '/tai-san/dieu-chinh-gia-tri-tscd',
      group: 0
    },
    {
      title: 'Điều chuyển bộ phận sử dụng TSCĐ',
      href: '/tai-san/dieu-chuyen-bo-phan-su-dung-tscd',
      group: 0
    },
    {
      title: 'Khai báo giảm TSCĐ',
      icon: <AritoIcon icon={325} />,
      href: '/tai-san/khai-bao-giam-tscd',
      group: 1
    },
    {
      title: 'Khai báo tạm dừng khấu hao TSCĐ',
      icon: <AritoIcon icon={328} />,
      href: '/tai-san/khai-bao-tam-dung-khau-hao-tscd',
      group: 1
    },
    {
      title: 'Khai báo thôi khấu hao TSCĐ',
      icon: <AritoIcon icon={332} />,
      href: '/tai-san/khai-bao-thoi-khau-hao-tscd',
      group: 1
    },
    {
      title: 'Điều chỉnh khấu hao tháng',
      href: '/tai-san/dieu-chinh-khau-hao-thang',
      group: 1
    },
    {
      title: 'Điều chuyển TSCĐ',
      items: [
        {
          title: 'Điều chuyển bộ phận sử dụng tài sản cố định',
          icon: <AritoIcon icon={329} />,
          href: '/tai-san/dieu-chuyen-tscd/dieu-chuyen-bo-phan-su-dung-tscd'
        }
      ],
      group: 1
    },
    {
      title: 'Tính khấu hao TSCĐ',
      items: [
        {
          title: 'Tính khấu hao và hạch toán tài sản cố định',
          icon: <AritoIcon icon={167} />,
          href: '/tai-san/tinh-khau-hao-tscd/tinh-khau-hao-va-hach-toan-tai-san-co-dinh'
        }
      ],
      group: 2
    },
    {
      title: 'Khai báo hệ số phân bổ khấu hao TSCĐ',
      href: '/tai-san/khai-bao-he-so-phan-bo-khau-hao-tscd',
      group: 2
    },
    {
      title: 'Kiểm kê TSCĐ',
      icon: <AritoIcon icon={727} />,
      items: [
        {
          title: 'Danh mục TSCĐ',
          icon: <AritoIcon icon={551} />,
          href: '/tai-san/kiem-ke-tscd/danh-muc-tscd'
        },
        {
          title: 'Thẻ TSCĐ',
          icon: <AritoIcon icon={792} />,
          href: '/tai-san/kiem-ke-tscd/the-tscd'
        },
        {
          title: 'Sổ TSCĐ',
          icon: <AritoIcon icon={692} />,
          href: '/tai-san/kiem-ke-tscd/so-tscd'
        }
      ],
      group: 3
    },
    {
      title: 'Tăng/giảm TSCĐ',
      icon: <AritoIcon icon={55} />,
      items: [
        {
          title: 'Bảng kê TSCĐ hết khấu hao còn sử dụng',
          icon: <AritoIcon icon={552} />,
          href: '/tai-san/tang-giam-tscd/bang-ke-tscd-het-khau-hao-con-su-dung'
        },
        {
          title: 'Báo cáo chi tiết tăng/giảm TSCĐ',
          icon: <AritoIcon icon={629} />,
          href: '/tai-san/tang-giam-tscd/bao-cao-chi-tiet-tang-giam-tscd'
        },
        {
          title: 'Báo cáo chi tiết tình hình tăng giảm TSCĐ',
          icon: <AritoIcon icon={756} />,
          href: '/tai-san/tang-giam-tscd/bao-cao-chi-tiet-tinh-hinh-tang-giam-tscd'
        },
        {
          title: 'Báo cáo tổng hợp tình hình tăng giảm TSCĐ',
          icon: <AritoIcon icon={233} />,
          href: '/tai-san/tang-giam-tscd/bao-cao-tong-hop-tinh-hinh-tang-giam-tscd'
        },
        {
          title: 'Bảng tính khấu hao TSCĐ',
          href: '/tai-san/tang-giam-tscd/bang-tinh-khau-hao-tscd'
        },
        {
          title: 'Bảng tính khấu hao TSCĐ theo tháng',
          href: '/tai-san/tang-giam-tscd/bang-tinh-khau-hao-tscd-theo-thang'
        }
      ],
      group: 3
    }
  ]
};
